module.exports = __webpack_public_path__ + "static/media/cloud_arrow.3c822296.svg";